// Simple localStorage-based persistence with JSON safety and namespacing

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export function readJson(key, fallback) {
  if (!isBrowser) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writeJson(key, value) {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota or serialization errors
  }
}

export function remove(key) {
  if (!isBrowser) return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function withNamespace(namespace, key) {
  return `${namespace}:${key}`;
}


